import React from 'react';

const SpecificationsSection = ({ formData, setFormData }) => {
  const specs = formData.specifications || {};

  const addRow = () => {
    const keys = Object.keys(specs);
    const newKey = `spec_${keys.length + 1}`;
    setFormData(prev => ({
      ...prev,
      specifications: { ...prev.specifications, [newKey]: '' }
    }));
  };

  const removeRow = (key) => {
    const updated = { ...specs };
    delete updated[key];
    setFormData(prev => ({ ...prev, specifications: updated }));
  };

  const updateValue = (key, value) => {
    setFormData(prev => ({
      ...prev,
      specifications: { ...prev.specifications, [key]: value }
    }));
  };

  return (
    <div className="form-section">
      <h3>Specifications</h3>
      <p className="text-muted">Add key-value pairs for product specifications.</p>
      <div className="spec-editor">
        {Object.entries(specs).length === 0 && (
          <p className="text-muted">No specifications added yet.</p>
        )}
        {Object.entries(specs).map(([key, value]) => (
          <div key={key} className="spec-row">
            <input
              type="text"
              className="form-control spec-key"
              value={key}
              onChange={(e) => {
                // Remove old, add new key with same value
                const updated = { ...specs };
                delete updated[key];
                if (e.target.value.trim()) {
                  updated[e.target.value.trim()] = value;
                }
                setFormData(prev => ({ ...prev, specifications: updated }));
              }}
              placeholder="Key"
            />
            <input
              type="text"
              className="form-control spec-value"
              value={value}
              onChange={(e) => updateValue(key, e.target.value)}
              placeholder="Value"
            />
            <button
              type="button"
              className="btn btn-sm btn-danger"
              onClick={() => removeRow(key)}
              title="Remove"
            >
              ×
            </button>
          </div>
        ))}
        <button
          type="button"
          className="btn btn-sm btn-outline"
          onClick={addRow}
          style={{ marginTop: '8px' }}
        >
          + Add Specification
        </button>
      </div>
    </div>
  );
};

export default SpecificationsSection;
